import React from 'react'
import { Container as Cont, Row } from 'styled-bootstrap-grid'
import styled from 'styled-components'
import { media } from 'styled-bootstrap-grid'
import SocialLinks from '../../containers/SocialLinks'
import { SubscribeForm } from '../../components'
import { CallAvailability } from '../../components'
import { rem } from '../../styles/Mixins'
import { StaticQuery, graphql } from 'gatsby'
import { withNullErrorBoundary } from '../../utils/withNullErrorBoundary'

const SocialLinksStyled = styled(SocialLinks)`
  display: none;

  ${media.lg`
    display: block;
  `}
`

const CallAvailabilityStyled = styled(CallAvailability)`
  padding-top: ${rem(20)};
  justify-content: center;
  color: ${(props) => props.theme.colors.primary};

  ${media.lg`
    display: none;
  `}
`

const SubscribeWrapper = styled.section`
  background-color: ${(props) => props.theme.colors.grey_300};
  padding: ${rem(35)} 0;
  text-align: center;

  @media print and (min-width: 1px) {
    display: none !important;
  }

  ${media.lg`
    /* padding: 28px 0; */
  `}

  ${media.lg`
    padding: ${rem(28, 'xxxl')} 0;
  `}
`

const Container = styled(Cont)`
  ${media.sm`
    padding: 0 20px;
  `}

  ${media.xl`
    padding: 0;
    max-width: ${(props) =>
      props.theme.settings.container_horizontal_maxWidth_xl};
  `}

  ${media.xxl`
    max-width: ${(props) =>
      props.theme.settings.container_horizontal_maxWidth_xxl};
  `}

  @media (min-width: 1920px) {
    max-width: 1348px;
  }
`

const SubscribeTitle = styled.h4`
  color: ${(props) => props.theme.colors.primary};
  text-transform: uppercase;
  font-size: ${rem(17)};
  margin: 0;
  margin-bottom: ${rem(14)};
  font-family: 'foco_cc_bold', sans-serif;

  ${media.md`
    margin-bottom: 0;
  `}

  ${media.lg`
    margin-top: 6px;
  `}

  ${media.xl`
    font-size: ${rem(24, 'xxxl')};
    margin-top: 2px;
  `}
`

const SubscribeText = styled.p`
  color: ${(props) => props.theme.colors.grey};
  font-size: ${rem(12)};
  margin: 0;
  margin-bottom: ${rem(28)};
  line-height: ${rem(18)};

  ${media.md`
    margin-bottom: 0;
    padding-left: ${rem(30)};
  `}

  ${media.lg`
    padding-left: 0;
    padding-right: ${rem(20)};
  `}

  ${media.xl`
    padding-right: ${rem(35, 'xxxl')};
    font-size: ${rem(16, 'xxxl')};
    line-height: ${rem(25, 'xxxl')};
  `}
`

const SubscribeTitleCol = styled.div`
  width: 100%;

  ${media.sm`
    width: 18%;
    display: flex;
    justify-content: flex-start;
  `}

  ${media.md`
    width: 15%;
  `}

  ${media.lg`
    width: 12%;
    order: 1;
    align-items: flex-start;
  `}

  ${media.xl`
    width: 12%;
  `}
`

const SubscribeFormCol = styled.div`
  width: 100%;
  padding: 0 10px;

  ${media.sm`
    width: 82%;
    padding: 0;
  `}

  ${media.md`
    width: 50%;
  `}

  ${media.lg`
    width: 34%;
    order: 3;
  `}

  ${media.xl`
    width: 34%;
  `}
`

const SubscribeTextCol = styled.div`
  width: 100%;

  ${media.md`
    width: 35%;
    display: flex;
    text-align: left;
  `}

  ${media.lg`
    width: 23%;
    order: 2;
  `}

  ${media.xl`
    width: 20%;
  `}
`

const SubscribeSocialCol = styled.div`
  width: 100%;
  border-top: 2px solid ${(props) => props.theme.colors.grey_100};

  ${media.md`
    margin-top: ${rem(33)};
  `}

  ${media.lg`
    width: 31%;
    border: none;
    display: flex;
    justify-content: flex-end;
    margin-top: ${rem(6)};
    order: 4;
  `}

  ${media.xl`
    width: 34%;
  `}
`

const Subscribe = (props) => {
  return (
    <StaticQuery
      query={graphql`
        query NewsletterQuery {
          wp {
            cancerCouncilSettings {
              acfSiteSettings {
                newsletterCta
                newsletterTitle
              }
            }
          }
        }
      `}
      render={(data) => {
        return (
          <SubscribeWrapper>
            <Container>
              <Row>
                <SubscribeTitleCol>
                  <SubscribeTitle>
                    {
                      data.wp.cancerCouncilSettings.acfSiteSettings
                        .newsletterTitle
                    }
                  </SubscribeTitle>
                </SubscribeTitleCol>
                <SubscribeFormCol>
                  <SubscribeForm awsEndpoint={props?.awsEndpoint} />
                </SubscribeFormCol>
                <SubscribeTextCol>
                  <SubscribeText>
                    {
                      data.wp.cancerCouncilSettings.acfSiteSettings
                        .newsletterCta
                    }
                  </SubscribeText>
                </SubscribeTextCol>
                <SubscribeSocialCol>
                  <SocialLinksStyled invert={true} />
                  <CallAvailabilityStyled available={true} horizontal={true} />
                </SubscribeSocialCol>
              </Row>
            </Container>
          </SubscribeWrapper>
        )
      }}
    ></StaticQuery>
  )
}

export default withNullErrorBoundary(Subscribe)
